import React from 'react';
import { FuelCallout, FuelTypography } from '@frete.com/fuel-react';
import { DisclaimerPropsInterface } from './DisclaimerTypes';
import * as Styled from './DisclaimerStyles';
import { dataMap } from './DisclaimerContants';

function Disclaimer({ slug }: DisclaimerPropsInterface) {
  if (!slug) {
    return null;
  }
  const disclaimerData = dataMap[slug];

  if (!disclaimerData) {
    return null;
  }

  return (
    <FuelCallout
      color={disclaimerData.color}
      icon={disclaimerData.icon.name}
      iconStyle={disclaimerData.icon.styled}
    >
      <Styled.Wrapper slot="content">
        <FuelTypography size="caption">
          <strong>{disclaimerData.highlight}</strong>{' '}
          {disclaimerData.description}
        </FuelTypography>
      </Styled.Wrapper>
    </FuelCallout>
  );
}

export default Disclaimer;
